import { render, staticRenderFns } from "./settingsDetailModal.vue?vue&type=template&id=edd3f5e4&scoped=true"
import script from "./settingsDetailModal.vue?vue&type=script&lang=js"
export * from "./settingsDetailModal.vue?vue&type=script&lang=js"
import style0 from "./settingsDetailModal.vue?vue&type=style&index=0&id=edd3f5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd3f5e4",
  null
  
)

export default component.exports